import { ButtonBase, ButtonBaseProps, Stack, Typography } from "@mui/material";
import { useGlobalContext } from "../../stores/Global";
import { MouseEventHandler } from "react";

interface SideBarButtonBaseProps {
  icon?: any;
  value: string;
  matched: boolean;
  buttonBaseProps?: ButtonBaseProps;
  forceViewText?: boolean;
  forceHideTooltip?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export default function SideBarButtonBase(props: SideBarButtonBaseProps) {
  const { context } = useGlobalContext();

  return (
    <ButtonBase
      {...props.buttonBaseProps}
      sx={{
        display: "flex",
        flexDirection: context.sidebar ? "row" : "column",
        alignItems: "center",
        justifyContent: context.sidebar ? "flex-start" : "center",
        borderRadius: (theme) => (theme.shape.borderRadius as number) / 8,
        transitionDuration: "200ms",
        p: context.sidebar ? 2 : 1,
        py: 1,
        fontWeight: "light",
        color: props.matched
          ? (theme) => theme.palette.primary.main
          : (theme) => theme.palette.text.secondary,
        background: props.matched
          ? (theme) => theme.palette.background.paper
          : "none",
        ":hover": {
          color: (theme) =>
            props.matched
              ? theme.palette.primary.main
              : theme.palette.text.primary,
          background: (theme) => theme.palette.background.paper,
        },
        ":hover > p": {
          transitionDuration: "600ms",
          ml: 1,
        },
        ...props.buttonBaseProps?.sx,
      }}
      onClick={props.onClick}
      focusRipple
    >
      <Stack
        direction={context.sidebar ? "row" : undefined}
        alignItems="center"
      >
        {props.icon}
        {(context.sidebar || props.forceViewText) && (
          <Typography fontWeight={500} pl={props.icon ? 1 : 0}>
            {props.value}
          </Typography>
        )}
        {!context.sidebar && !props.forceViewText && (
          <Typography fontWeight={500} fontSize={9}>
            {props.value}
          </Typography>
        )}
      </Stack>
    </ButtonBase>
  );
}
